import { useSelector, useDispatch } from 'react-redux';
import guoZhaoSlice from './guoZhaoSlice';

function useGuoZhao() {
    const { guoZhao } = useSelector((state) => {
        return state.guoZhao;
    });
    const dispatch = useDispatch();
  
    function setGuoZhao(guoZhao) {
      dispatch(guoZhaoSlice.actions.setGuoZhao(guoZhao));
    }
  
    return { guoZhao, setGuoZhao };
}

export default useGuoZhao;